export const environment = {
    production: false,
    name: 'staging',
    modul: 'bildverifizierung',
    bildverifizierungUrl: 'https://bildverifizierung-staging.algo-esg.app',
    sse_environment: 'https://zutrittsereignisse-staging.algo-esg.app',
    keycloak: {
        realm: 'algo',
        url: 'https://identity.algo-esg.app',
        clientId: 'algoBildverifizierungStaging',
    },
};
